<h2 *ngIf="isShowTitle || canEdit || isShowHistory">
    <ng-container *ngIf="isShowTitle">Contacts</ng-container>
    <ng-container *ngIf="!isShowTitle">&nbsp;</ng-container>
    <button class="icon--add btn--default" type="button" *ngIf="canEdit" (click)="addContact()">Add Contact</button>
    <button class="icon--history btn--default" type="button" *ngIf="isShowHistory" (click)="showHistory(customerNumber)">View History</button>
</h2>
<p-table id="Customer"
         #dt
         styleClass="p-datatable-striped"
         [value]="contacts">

    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="w--arrow" *ngIf="isShowSelect"></th>
            <th>Type</th>
            <th>Contact</th>
            <th>Text/Email Enabled</th>
            <th class="w--actions">Primary</th>
            <th class="w--190">Preferred Contact Method</th>
            <th class="w--actions">Invalid</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="6 + (!!canEdit ? 1 : 0) + (!!isShowSelect ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td *ngIf="isShowSelect">
                <p-radioButton name="selectedContact" [value]="data.id" [(ngModel)]="selectedContact" (click)="onSelectChanged(data)"></p-radioButton>
            </td>
            <td>
                {{data.contactType}}
            </td>
            <td class="td--hover-show">
                {{data.customerContactValue}}
            </td>
            <td>
                <checkbox [checked]="data.isCorrespondenceEnabled" disabled *ngIf="data.contactMethodTypeId == 1 || data.contactMethodTypeId == 2 || data.contactMethodTypeId == 5 || data.contactMethodTypeId == 6"></checkbox>
            </td>
            <td>
                <checkbox [checked]="data.isPrimary" disabled *ngIf="data.contactMethodTypeId < 7"></checkbox>
            </td>
            <td>
                <checkbox [checked]="data.isPreferredContactMethod" disabled *ngIf="data.contactMethodTypeId == 5 || data.contactMethodTypeId == 6"></checkbox>
            </td>
            <td>
                <checkbox [checked]="data.isInvalid" disabled *ngIf="data.contactMethodTypeId < 7"></checkbox>
            </td>
            <td class="text-center" *ngIf="canEdit">
                <a [ngClass]="{'disabled': isFullRedactionNecessary}" class="icon--edit" title="Edit Contact" href="javascript:void(0);" (click)="editContact(data.id)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>